import React from 'react';

import Para from '../../Atoms/Para';

const WelcomeMessageContent = () => (
    <Para
        text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet nisl at
        turpis mollis dignissim. Duis in porttitor purus. Vestibulum dolor lacus, posuere et est at,
        euismod accumsan ligula. Sed lacinia nunc urna, non aliquam lectus dapibus id. Cras auctor pharetra
        mollis. Maecenas vulputate finibus pretium. Etiam volutpat dui ac euismod aliquet. Donec nisl mi,
        viverra nec ullamcorper ut, convallis id tortor. Cras malesuada aliquet tortor a tincidunt. "
        styles=" text-base  mt-4 sm:text-lg leading-relaxed tracking-wide md:text-lg "
    />
);

export default WelcomeMessageContent;